import {connect} from 'react-redux';
import Form_9 from './Form_9';
import {getShumaStepStatus} from '../../actions/steps/getShumaStepStatus';

const mapStateToProps = ({
                           user: {allowInspectionsShare},
                         }) => ({
  allowInspectionsShare
});

export default connect(
  mapStateToProps,
  {getShumaStepStatus}
)(Form_9);
